import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { TResponse } from '@r1-frontend/do-request/core/types';
import { BaseErrorBody } from '@r1-frontend/do-request/error';
import setTvPackets, { ResponseDto } from '@r1-frontend/api-domru/api-profile/v2/tv-packets/set-tv-packet';

import { TState } from '~/src/store';

interface IConnectParams {
    isClosePacket: boolean,
    packetId: number,
    duration: number,
    raId: number,
    terminalId?: number,
}

interface ISetTvPacketConnection {
    isConnectingInProgress: boolean,
    onConnectPackage: () => Promise<TResponse<ResponseDto, BaseErrorBody>>,
}

export const useConnectPackage = (params: IConnectParams): ISetTvPacketConnection => {
    const {
        tvPackages: { terminalId: trId },
    } = useSelector((state: TState) => state);

    const [isConnectingInProgress, setIsConnectingInProgress] = useState(false);
    const { isClosePacket, packetId, duration, raId, terminalId } = params;

    const onConnectPackage = useCallback(async() => {
        setIsConnectingInProgress(true);
        const reqParams = {
            closePacket: duration ? +isClosePacket : 0,
            packetId,
            raId,
            trId: trId || terminalId,
        };

        const resp = await doRequest.apiProfile<ResponseDto>(setTvPackets(reqParams));
        setIsConnectingInProgress(false);

        return resp;
    }, [duration, isClosePacket, packetId, raId, trId, terminalId]);

    return { isConnectingInProgress, onConnectPackage };
};
